/**
 * Shim do componente `Hidden` (removido em MUI v5).
 *
 * Reproduz a API mínima usada no coruja:
 *   <Hidden smDown>...</Hidden>  → esconde em telas <= sm
 *   <Hidden mdUp>...</Hidden>    → esconde em telas >= md
 *   <Hidden only="xs">...</Hidden>
 *
 * Pra migração definitiva, MUI recomenda `sx={{ display: ... }}` ou
 * `useMediaQuery` direto. Este shim mantém o código existente funcional
 * até refatoração futura.
 *
 * @module components/HiddenShim
 */
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];

export default function Hidden({
  children,
  xsDown,
  smDown,
  mdDown,
  lgDown,
  xlDown,
  xsUp,
  smUp,
  mdUp,
  lgUp,
  xlUp,
  only,
}) {
  const theme = useTheme();
  // useMediaQuery não pode ser chamado condicionalmente — sempre chama todas.
  const queries = {
    xsDown: useMediaQuery(theme.breakpoints.down('sm')),
    smDown: useMediaQuery(theme.breakpoints.down('md')),
    mdDown: useMediaQuery(theme.breakpoints.down('lg')),
    lgDown: useMediaQuery(theme.breakpoints.down('xl')),
    xlDown: useMediaQuery(theme.breakpoints.down('xl')),
    xsUp: useMediaQuery(theme.breakpoints.up('xs')),
    smUp: useMediaQuery(theme.breakpoints.up('sm')),
    mdUp: useMediaQuery(theme.breakpoints.up('md')),
    lgUp: useMediaQuery(theme.breakpoints.up('lg')),
    xlUp: useMediaQuery(theme.breakpoints.up('xl')),
  };

  const flags = { xsDown, smDown, mdDown, lgDown, xlDown, xsUp, smUp, mdUp, lgUp, xlUp };
  for (const key of Object.keys(flags)) {
    if (flags[key] && queries[key]) return null;
  }

  if (only) {
    const onlyList = Array.isArray(only) ? only : [only];
    for (const bp of onlyList) {
      if (!BREAKPOINTS.includes(bp)) continue;
      const idx = BREAKPOINTS.indexOf(bp);
      const next = BREAKPOINTS[idx + 1];
      // hidden se tá EXATAMENTE no breakpoint atual
      const isAtBp =
        queries[`${bp}Up`] && (!next || !queries[`${next}Up`]);
      if (isAtBp) return null;
    }
  }

  return children;
}
